import React from 'react';
import { Row } from 'react-flexbox-grid';
import { getSpentPercent, roundForDisplay } from '../../../../containers/shared/util';

export const OverviewBodyInBudgetProgressBar = ({ spent, budgeted }) => {
  let spentPercent = roundForDisplay(getSpentPercent(spent, budgeted));
  let splitColor = `-webkit-linear-gradient(0deg, #39CF71 ${spentPercent}%, #D3D5D8 0%)`;
  return <Row className="overview-body-in-budget-progress-bar" style={{ backgroundImage: splitColor }} />;
};
